import { render, staticRenderFns } from "./c_acente_sozlesme.vue?vue&type=template&id=73b6910c"
import script from "./c_acente_sozlesme.vue?vue&type=script&lang=js"
export * from "./c_acente_sozlesme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports